export function headerNav() {
    const header = $(".main-header");
    const menuBtn = header.find(".menu-btn");
    const navigation = header.find("nav");
    const mainNav = navigation.find(".main-nav");
    const subNav = mainNav.find(".sub-menu");
    const expandBtnTemplate = "<strong class=\"expand-btn\"></strong>";

    menuBtn.on("click", function () {
        header.toggleClass("active");
    });

    subNav.parents("li").addClass("extended").append(expandBtnTemplate);

    $(document).on("click", function (event) {
        if ($(event.target).hasClass("expand-btn")) {
            $(event.target).parents(".extended").toggleClass("expanded");
        } else {
            $(".extended").removeClass("expanded");
        }
    });
    if(window.innerWidth > 1199) {
        subNav.each(function () {
            let list = $(this);
            let listItems = list.find("li");
            if(listItems.length < 3) {
                list.css({width: "auto", columnCount: "1"});
                listItems.css({width: "auto", marginRight: "10px"});
            }
        });
    }
    $(window).on("resize", () => {
        if(window.innerWidth > 1199) {
            if(header.hasClass("active")) {
                header.removeClass("active");
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerNav.js